import { useApolloClient } from '@apollo/client';

import { BusinessPlaylistType } from '@shared/api/fragments.graphql';

import { BUSINESS_PROFILE_SET_SELECTED_PLAYLIST_QUERY } from './consts';
import { BusinessProfileSelectedPlaylistType, CurrentPlaylistCachedData } from './types';

const useBusinessProfileSelectedPlaylist = () => {
  const client = useApolloClient();

  const getBusinessProfilePlaylist = (id: string) => {
    const businessProfilePlaylistData = client.readQuery<CurrentPlaylistCachedData>({
      query: BUSINESS_PROFILE_SET_SELECTED_PLAYLIST_QUERY,
    });

    if (
      businessProfilePlaylistData &&
      Object.keys(businessProfilePlaylistData).length !== 0 &&
      businessProfilePlaylistData.playlist.id === id
    ) {
      return businessProfilePlaylistData.playlist;
    }

    const businessProfilePlaylist = client.readFragment({
      id: `ZvukPlaylistType:${id}`,
      fragment: BusinessPlaylistType,
      fragmentName: 'BusinessPlaylistType',
    });

    return businessProfilePlaylist;
  };

  const setSelectedBusinessProfilePlaylist = (playlist: BusinessProfileSelectedPlaylistType) => {
    const queryData = {
      playlist,
    };

    const businessProfilePlaylist = client.writeQuery({
      query: BUSINESS_PROFILE_SET_SELECTED_PLAYLIST_QUERY,
      data: queryData,
    });

    return !!businessProfilePlaylist;
  };

  const removeSelectedBusinessProfilePlaylist = (playlistId: string) => {
    const normalizedId = client.cache.identify({ id: playlistId, __typename: 'ZvukPlaylistType' });
    client.cache.evict({ id: normalizedId });
    client.cache.gc();
  };

  return {
    getBusinessProfilePlaylist,
    setSelectedBusinessProfilePlaylist,
    removeSelectedBusinessProfilePlaylist,
  };
};

export default useBusinessProfileSelectedPlaylist;
